<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">

        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Controle de Contratos</b>
            </h3>
            <router-link
              tag="a"
              class="btn btn-primary pull-right"
              to="/distribuicoes/contratos/novo"
              v-if="hasPermission('usuario.write')"
            >
              <i class="fa fa-plus"></i> Novo
            </router-link>
          </div>

          <div class="box-body">
            <div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label for>Unidade</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="filtros.pesquisa"
                      placeholder="Pesquisa: Entre com NOME DA UNIDADE"
                      @keyup.enter="getDataTable"
                    />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label for>Categoria</label>
                    <select v-model="filtros.categoria_unidade" class="form-control">
                      <option value>--Categoria--</option>
                      <option value="0">Pública (Local)</option>
                      <option value="1">Município Pactuado (PPI)</option>
                      <option value="2">Privada</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label for>Tipo</label>
                    <select v-model="filtros.tipo" class="form-control">
                      <option value>--Tipo--</option>
                      <option value="0">Solicitante</option>
                      <option value="1">Prestador</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for>Competência</label>
                    <select v-model="filtros.distribuicao_id" class="form-control">
                      <option
                        v-for="(distribuicao, index) in distribuicoes"
                        :value="distribuicao.id"
                        :key="index"
                      >{{ distribuicao.data_competencia | competencia }}</option>
                    </select>
                  </div>
                </div>
				  <div class="col-md-2">
					  <div class="form-group">
						  <label for>Situação</label>
						  <select v-model="filtros.situacao" class="form-control">
							  <option value>--Situação--</option>
							  <option value="1">Ativo</option>
							  <option value="0">Inativo</option>
						  </select>
					  </div>
				  </div>
                <div class="col-md-1">
                  <div class="form-group">
                       <label class>&nbsp;</label>
                    <button @click="getDataTable" class="btn btn-default btn-block">
                      <span class="fa fa-filter"></span> Filtrar
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example1"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr role="row">
                      <th style="width: 10%;">
                        ID
                        <span
                          @click="sortByKey('distribuicao_contratos.id')"
                          class="icon-ordenacao"
                        >
                          <i
                            :class="filtros.ordem && filtros.coluna == 'distribuicao_contratos.id' ? `fa fa-sort-numeric${'-' + filtros.ordem}` : 'fa fa-sort'"
                          ></i>
                        </span>
                      </th>
                      <th style="width: auto;">
                        Unidade
                        <span @click="sortByKey('unidades.nome')" class="icon-ordenacao">
                          <i
                            :class="filtros.ordem && filtros.coluna == 'unidades.nome' ? `fa fa-sort-alpha${'-' + filtros.ordem}` : 'fa fa-sort'"
                          ></i>
                        </span>
                      </th>
                      <th style="width: auto;">Categoria</th>
                      <th style="width: auto;">Tipo</th>
                      <th style="width: auto;">Data Inicial</th>
                      <th style="width: auto;">Data Final</th>
                      <th style="width: auto;">Situação</th>
                      <th style="width: 15%">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="item in dataTable.data" :key="item.id">
                      <td>{{ item.id }}</td>
                      <td>{{ item.nome }}</td>
                      <td>{{ item.categoria | categoriaUnidade }}</td>
                      <td>{{ item.tipo | tipoContrato }}</td>
                      <td>{{ item.data_inicial | dataFormatada }}</td>
                      <td>{{ item.data_final | dataFormatada }}</td>
                      <td>{{ item.situacao | situacao }}</td>
                      <td>
                        <router-link
                          tag="button"
                          class="btn btn-warning btn-sm"
                          :to="`/distribuicoes/contratos/atualizacao/${item.id}`"
                          title="Editar"
                        >
                          <i style="font-size:12px" class="fa fa-fw fa-edit"></i>
                        </router-link>
                        <router-link
                          tag="button"
                          class="btn btn-success btn-sm"
                          :to="`/distribuicoes/contratos/procedimentos/${item.id}`"
                          title=" Procedimentos do Contrato"
                        >
                          <i style="font-size:12px" class="fa fa-fw fa-list"></i>
                        </router-link>
                        <router-link
                          tag="button"
                          class="btn btn-info btn-sm"
                          :to="`/distribuicoes/contratos/subgrupos/${item.id}`"
                          title="Subgrupos do Contrato"
                        >
                          <i style="font-size:12px" class="fa fa-fw fa-list-alt"></i>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div
                    class="col-sm-5"
                  >Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>

                  <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination
                      :limit="5"
                      :data="dataTable"
                      v-on:pagination-change-page="getDataTable"
                    >
                      <span slot="prev-nav">&lt; Anterior</span>
                      <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http

export default {
  filters: {},
  data: () => ({
       distribuicoes: [],
    filtros: {
      distribuicao_id: "",
      pesquisa: "",
      categoria_unidade: "",
      tipo: "",
      situacao: "",
      coluna: null,
      ordem: null
    },
    dataTable: {}
  }),
  mounted() {
    this.filtros.pesquisa = this.$route.query.pesquisa
      ? this.$route.query.pesquisa
      : "";
    this.getDistribuicoes();

  },
  methods: {
    getDistribuicoes() {
      axios
        .get(
          `${this.$store.state.serverURI}/api/distribuicao/getAll`,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          this.distribuicoes = response.data;
          this.filtros.distribuicao_id = this.distribuicoes[0].id;
          this.getDataTable();
        })
        .catch(error => {
          console.log(error);
        });
    },
    sortByKey: function(field) {
      this.filtros.coluna = field;
      if (this.filtros.ordem == "asc") {
        this.filtros.ordem = "desc";
      } else {
        this.filtros.ordem = "asc";
      }
      this.getDataTable();
    },

    getDataTable(page) {
      if (typeof page === "undefined") {
        page = 1;
      }

      this.filtros.page = page;
      this.$store.commit("TOGGLE_LOADING");
      this.$router.push({ query: this.filtros });

      let config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;
      axios
        .get(
          `${this.$store.state.serverURI}/api/distribuicao/contratos/getAllPaginate`,
          config
        )
        .then(response => {
          this.dataTable = response.data;
          this.$store.commit("TOGGLE_LOADING");
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    },
    delete(id, nome) {
      /*
                var self = this;
                this.$dialog.confirm(`Tem certeza que deseja desativar o usuário "${nome}"? \nObs.: Nenhum dado pode ser apagado permanentemente do sistema!`, { okText: 'Sim',
                    cancelText: 'Não' })
                .then(function () {
                    axios.delete(`${self.$store.state.serverURI}/api/usuario/delete/` + id, self.$store.getters.getHeaderAuth).then(response => {
                        self.$store.commit('TOGGLE_LOADING');
                        self.$store.commit('SHOW_ALERT_SUCCESS');
                        self.getUsers();

                    }).catch((error) => {
                        self.$store.commit('SHOW_ALERT_ERROR');
                        console.log(error)
                    });
                })
                */
    }
  },
  watch: {
    page: function(val) {
      this.getDataTable();
    }
  },

  components: {
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// index.vue?1cb31485